export default __webpack_public_path__ + "static/media/atencion_prenatal.aa4b0424.pdf";